
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class RecruitingProfileInfo extends Vue {
	@Prop({required:true}) label: string;
}
